// export interface dataStructureForPie {
//   value: number;
//   name: string;
//   itemStyle: { color: string };
// }
function addPaddingToPieData(data, paddingValue = 0.5) {
  const dataWithPadding = [];
  const padding = {
    value: paddingValue,
    name: 'padding',
    itemStyle: { color: '#ffffff', opacity: 0 },
  };
  const dataGreaterThanZero = data.filter(({ value }) => value > 0);
  if (dataGreaterThanZero.length === 0) {
    return [
      {
        value: 100,
        name: 'empty',
        itemStyle: { color: '#c2c2c2' },
      },
    ];
  } else if (dataGreaterThanZero.length === 1) {
    return data;
  }
  for (const singleData of data ?? []) {
    dataWithPadding.push(
      singleData,
      singleData.value === 100 || singleData.value === 0 || singleData.value === '0.00' ? {} : padding
    );
  }
  return dataWithPadding;
}

export default addPaddingToPieData;
